
import { defineComponent, PropType } from 'vue';
import Message from '@/models/MessageModel';
import AnswerButton from '@/components/App/AnswerButton/index.vue';

import MessageWrap from '@/components/MessageWrap/index.vue';

export default defineComponent({
	name: 'choice',

	components: {
		MessageWrap,
		AnswerButton
	},

	props: {
		message: {
			type: Object as PropType<Message>
		},

		isShowMessageTail: {
			type: Boolean
		},

		isLastMessage: {
			type: Boolean
		},

		avatar: {
			type: String
		}
	},

	emits: ['send-message', 'init'],

	mounted() {
		this.$emit('init');
	}
});
